<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Home",
  beforeCreate() {
    if(window.location.host == 'lp1srv.lt' && window.location.protocol == 'http:')
    {
      window.location.href = "https://lp1srv.lt";
    }
    if (!this.$session.exists()) {
      this.$router.push({ name: "login" }).catch(() => {});
    } else if (
      this.$router.currentRoute.fullPath ==
      "/" + this.$router.currentRoute.params.lang
    ) {
      this.$router.push({ name: "login" }).catch(() => {});
    } else {
      this.$router.push({ path: `${this.$router.currentRoute.fullPath}` }).catch(() => {});
    }
  }
};
</script>

<style>
</style>